'use client';

import clsx from 'clsx';
import Link from 'next/link';
import { FC } from 'react';
import Icon from '~/components/icon';

import styles from './styles.module.css';

interface Props {
  onNext?: () => void;
  onPrev?: () => void;
  hrefNext?: string;
  hrefPrev?: string;
  containerClassName?: string;
}

const SliderNavigation: FC<Props> = ({ onNext, onPrev, hrefNext, hrefPrev, containerClassName }) => {
  return (
    <div className={clsx(styles.container, containerClassName)}>
      {hrefPrev ? (
        <Link href={hrefPrev} className={clsx(styles.button, styles.buttonPrev)} aria-label="предыдущий слайд">
          <Icon name="slider-arrow" />
        </Link>
      ) : (
        <button className={clsx(styles.button, styles.buttonPrev)} onClick={onPrev} aria-label="предыдущий слайд">
          <Icon name="slider-arrow" />
        </button>
      )}
      {hrefNext ? (
        <Link href={hrefNext} className={styles.button} aria-label="следующий слайд">
          <Icon name="slider-arrow" />
        </Link>
      ) : (
        <button className={styles.button} onClick={onNext} aria-label="следующий слайд">
          <Icon name="slider-arrow" />
        </button>
      )}
    </div>
  );
};

export default SliderNavigation;
